"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Status = exports.Source = void 0;
var Source;
(function (Source) {
    Source["INBOUND_FLOW"] = "inboundFlow";
    Source["CROSSDOCK_SCAN"] = "crossDockScan";
})(Source = exports.Source || (exports.Source = {}));
var Status;
(function (Status) {
    Status["SELLER_CREATED"] = "seller.created";
    Status["CARRIER_SHIPPING"] = "carrier.shipping";
    Status["CROSSDOCK_SCANNED"] = "crossdock.scan";
})(Status = exports.Status || (exports.Status = {}));
//# sourceMappingURL=PackageStatus.js.map